import React from 'react';
import { withRouter } from 'react-router-dom';
import { trackPage } from 'shared/models/analytic';
import sessionStore from 'shared/utils/sessionStore';

class ScrollPreserver extends React.Component {
  componentDidUpdate(prevProps) {
    if (
      prevProps.location !== this.props.location &&
      this.props.history.action !== 'REPLACE' &&
      typeof window.scrollY !== 'undefined' &&
      window.scrollY !== 0
    ) {
      const key =
        (this.props.location.state || {}).from ||
        prevProps.location.key ||
        'root';
      const scrollKey = `scroll.${key}`;
      const scrollPos = [window.scrollX, window.scrollY].join(',');
      sessionStore.set(scrollKey, scrollPos);
    }

    const key =
      (this.props.location.state || {}).to || this.props.location.key || 'root';
    const scrollKey = `scroll.${key}`;
    const scrollPos = sessionStore.get(scrollKey);
    if (scrollPos) {
      const [x, y] = scrollPos.split(',');
      window.scrollTo(x, y);
      sessionStore.remove(scrollKey);
    } else if (
      prevProps.location &&
      this.props.location !== prevProps.location &&
      this.props.history.action !== 'REPLACE'
    ) {
      window.scrollTo(0, 0);
      setTimeout(trackPage, 500);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollPreserver);
